export default __webpack_public_path__ + "static/media/heart.7456b10c.svg";